import * as React from 'react';
import { ExternalLink } from '@components/atoms';
import { Button, ButtonSize, ButtonVariant } from '@components/molecules';
import { cn } from '@utils';

interface IExternalActionLinkProps {
	href?: string;
	label: string;
	testId?: string;
	className?: string;
	iconClassName?: string;
}

const ExternalActionLink = React.memo(
	({ href, label, testId, className, iconClassName }: IExternalActionLinkProps) => (
		<Button asChild variant={ButtonVariant.HYPERLINK} size={ButtonSize.SM} className={className}>
			<a href={href} target="_blank" rel="noopener noreferrer" data-testid={testId}>
				{label}
				<ExternalLink className={cn('ml-1.5 inline-flex h-4 w-4', iconClassName)} />
			</a>
		</Button>
	)
);
ExternalActionLink.displayName = 'ExternalActionLink';

export { ExternalActionLink };
export type { IExternalActionLinkProps };
